import ButtonContainer from "@components/ButtonContainer";
import Condition from "@components/EasyDev/form/Condition";
import Select from "@components/EasyDev/form/Select";
import Loader from "@components/Loader";
import FileUpload from "@components/Shared/FileUpload";
import FormTextareaField from "@components/Shared/FormTextareaField";
import { AwardCategory } from "@enums/awardCategory";
import { awardCategoryOptions } from "@helpers/award.helper";
import { getYearOptions, selectedYearOption } from "@helpers/yearSelect.helper";
import useGetSelectArtists from "@hooks/Artist/useGetSelectArtists";
import IFormProps from "@interfaces/Shared/formProps";
import { ReactElement } from "react";
import { Field } from "react-final-form";

const CreateForm = ({ handleSubmit }: IFormProps): ReactElement => {
  const { data: artists, loading } = useGetSelectArtists();
  const yearOptions = getYearOptions();

  if (loading || !artists) {
    return <Loader isInsideThing />;
  }

  return (
    <form className="form form--horizontal" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">Year</span>
        <div className="form__form-group-field">
          <Field
            name="year"
            component={Select}
            isAboveError
            placeholder="Enter Year"
            options={yearOptions}
            initialValue={selectedYearOption}
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Category</span>
        <div className="form__form-group-field">
          <Field
            name="category"
            component={Select}
            isAboveError
            placeholder="Enter Category"
            options={awardCategoryOptions}
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Artist</span>
        <div className="form__form-group-field">
          <Field
            name="artist"
            component={Select}
            placeholde="Enter Artist"
            isAboveError
            options={artists}
          />
        </div>
      </div>

      <Condition when="category.value" is={AwardCategory.WiseArtsChoice}>
        <div className="form__form-group">
          <span className="form__form-group-label">Summary</span>
          <div className="form__form-group-field">
            <Field
              name="summary"
              component={FormTextareaField}
              type="text"
              placeholder={"Enter a Summary"}
              isAboveError
            />
          </div>
        </div>

        <div className="form__form-group">
          <span className="form__form-group-label">Description</span>
          <div className="form__form-group-field">
            <Field
              name="description"
              component={FormTextareaField}
              type="text"
              placeholder={"Enter a Description"}
              isAboveError
            />
          </div>
        </div>

        <FileUpload title="Image" isSingle formFieldName="imageUrl" />
      </Condition>

      <ButtonContainer />
    </form>
  );
};

export default CreateForm;
